import { GetterTree } from "vuex";
import { TradeContractState } from "./model";
import { RootStateType } from "@/store";

const getters: GetterTree<TradeContractState, RootStateType> = {
};

export default getters;
